import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { ensureDefined, } from '@tymia/shared';
import { DateTime, } from 'luxon';
import { useEffect, useState, } from 'react';
import { api, } from '../../api/Api.js';
import { useTranslation, } from '../../useTranslation.js';
import { BookingComponent, } from './BookingComponent.js';
export function BookingWidget({ userId }) {
    const therapistId = ensureDefined(userId);
    const tRoot = useTranslation();
    const [apiResponse, setApiResponse] = useState();
    useEffect(() => {
        let isMounted = true;
        void (async () => {
            const response = await api.client.appointment.bookable.request({
                therapistId,
                startDate: DateTime.now()
                    .setLocale(tRoot.locale)
                    .startOf('week', { useLocaleWeeks: true }).toISO(),
            });
            if (isMounted && response.status === 'ok') {
                setApiResponse(response);
            }
        })();
        return () => {
            isMounted = false;
        };
    }, []);
    if (!apiResponse) {
        return _jsx(_Fragment, {});
    }
    return (_jsx(BookingComponent, { ...apiResponse, therapistId: therapistId }));
}
//# sourceMappingURL=BookingWidget.js.map